import { colors as asbcColors } from './asbc';
import { colors as asbisColors } from './asbis';
import { DOMAINS } from '~/domains/core/constants.d';

export const vuetifyThemeConfig = {
  ASBC: {
    name: DOMAINS.ASBC,
    colors: asbcColors,
    dark: false,
    variables: { 'border-opacity': 1 },
  },
  ASBIS: {
    name: DOMAINS.ASBIS,
    colors: asbisColors,
    dark: false,
    variables: {},
  },
  BREEZY: {
    name: DOMAINS.BREEZY,
    colors: asbisColors,
    dark: false,
    variables: {},
  },
} as const;

export type VuetifyThemeName = keyof typeof vuetifyThemeConfig;
